// Here are the values of keys healed by the localization module when done
// Edit the localize pipe to get the value from the module when done with it
// Edit this key to match the key in localization module

// button prefix
// 'aumico_button_'
// service prefix
// 'aumico_annual_report'

export const defaultLocalizationValues = {
    // buttons
    // aumico_button_save: 'Save',

    // // validations
    // aumico_annual_report_form_validation_enter_company_name_required: 'Please enter company name',

    // // annual report table
    aumico_annual_report_table_label_company: 'company',
    aumico_annual_report_table_label_currency: 'currency',
    aumico_annual_report_table_label_created_on: 'created on',
    aumico_annual_report_table_label_language: 'Language',
    aumico_annual_report_table_label_last_change: 'last change',
    aumico_annual_report_table_label_accounting_basis: 'accounting basis',
    aumico_annual_report_table_label_current_year_date: 'current year date',
    aumico_annual_report_table_label_previous_year_date: 'previous year date',
    aumico_annual_report_table_label_share_date: 'Shared On',
    aumico_annual_report_table_menu_option_display_archived: 'Display Archived',
    aumico_annual_report_table_menu_option_archive: 'Archive',
    aumico_annual_report_table_menu_option_display_active: 'Display Active',
    aumico_annual_report_table_menu_option_restore: 'Restore',
    aumico_annual_report_table_menu_option_delete: 'Delete',
    aumico_annual_report_table_menu_option_per_row_secure_share: 'Secure Share',

    // general information
    aumico_annual_report_general_information_autofill_from_previous_year_btn_text:
        'Autofill Annual Report From Previous Year',
    aumico_annual_report_general_information_select_company: 'Select company',
    aumico_annual_report_general_information_create_new_company_btn_text: 'Create new company',
    aumico_annual_report_general_information_set_specification: 'Set specifications',
    aumico_annual_report_general_information_balance_sheet_date: 'Balance sheet date (mandatory)',
    aumico_annual_report_general_information_date_from: 'From',
    aumico_annual_report_general_information_date_to: 'To',
    aumico_annual_report_general_information_current_year: 'Current year',
    aumico_annual_report_general_information_previous_period: 'Previous period',
    aumico_annual_report_general_information_balance_sheet: 'Balance sheet',
    aumico_annual_report_general_information_income_statement: 'Income statement',
    aumico_annual_report_general_information_previous_year_reporting_date: "Previous year's reporting date (mandatory)",
    aumico_annual_report_general_information_currency: 'Currency (mandatory)',
    aumico_annual_report_general_information_basis_of_accounting: 'Basis of accounting (mandatory)',
    aumico_annual_report_general_information_revision_type: 'Revision type (mandatory)',
    aumico_annual_report_general_information_please_select_company: 'Please select a company',
    aumico_annual_report_general_information_please_determine_date: 'Determine the balance sheet date',
    aumico_annual_report_general_information_please_determine_previous_year_date:
        'Determine the previous years key date',
    aumico_annual_report_general_information_please_determine_income_date: 'Determine the income statement date',
    aumico_annual_report_general_information_please_determine_currency: 'Determine the currency',
    aumico_annual_report_general_information_select_accounting_basis: 'Select the accounting basis',
    aumico_annual_report_general_information_select_revision_type: 'Select the revision type',
    aumico_annual_report_general_information_optional_or: 'or',
    aumico_annual_report_general_information_autofill_from_list_btn_text: 'Choose Annual Report for Autofill',
    aumico_annual_report_general_information_no_previous_data: 'No previous data',
    aumico_annual_report_general_information_take_autofill_from_previous_annual_report:
        'Take autofill from previous aumico annual report',
    aumico_annual_report_general_information_take_previous_data_from_annual_report:
        'Take previous data from previous aumico annual report',
    aumico_annual_report_general_information_options: 'Options',
    aumico_annual_report_general_information_company: 'Company',
    // errors
    aumico_annual_report_mandatory_field_error: 'This Field is Mandatory',
    aumico_annual_report_general_information_balance_sheet_date_error:
        'Balance Sheet Date Must Be Greater Than Previous Date',
    aumico_annual_report_general_information_previous_sheet_date_error:
        'Previous Sheet Date Must Be Less Than Balance Date',
    aumico_annual_report_general_information_income_current_date_from_error:
        'Income current from date must be less than current to date & greater than or equal previous to date',
    aumico_annual_report_general_information_income_current_date_to_error:
        'Income current to date must be greater than current from date',
    aumico_annual_report_general_information_income_previous_date_from_error:
        'Income previous from date must be less than previous to date',
    aumico_annual_report_general_information_income_previous_date_to_error:
        'Income previous to date must be less than or equal current from date & greater than previous from date',
    aumico_annual_report_not_found_error: 'Not Found',
    aumico_errors_server_error: 'Internal Server Error',

    // spreadsheet preview
    aumico_annual_report_file_preview: 'File preview',

    // import-definition
    aumico_annual_report_import_definition_which_spreadsheet_1: 'In which spreadsheet is the ',
    aumico_annual_report_import_definition_which_spreadsheet_2: ' sheet shown?',
    aumico_annual_report_import_definition_click_corresponding_sheet:
        'Please click on the corresponding sheet in the preview.',
    aumico_annual_report_import_definition_transfer_entries: 'Transfer entries for',
    aumico_annual_report_import_definition_fill_manually: 'Fill Manually',
    aumico_annual_report_import_definition_specify_data_start_line_1:
        'Specify the line number on which the data for accounts start',
    aumico_annual_report_import_definition_specify_titles_line_1:
        'Specify the line number on which the titles are fixed in the ',
    aumico_annual_report_import_definition_specify_titles_line_2: ' sheet.',
    aumico_annual_report_import_definition_click_cell: 'Please click on the corresponding cell in the preview.',
    aumico_annual_report_import_indicate_account_names_column: 'Indicate the column where the account names are fixed',
    aumico_annual_report_import_indicate_account_numbers_column:
        'Indicate the column where the account numbers are fixed',
    aumico_annual_report_import_indicate_balance_column: 'Indicate the column where the balance are fixed',
    aumico_annual_report_import_indicate_previous_year_column: 'Indicate the column where the previous year are fixed',
    aumico_annual_report_import_please_select: 'please select',

    // import-options
    aumico_annual_report_import_balance_and_income_from_separate_files_option:
        'Upload balance sheet & income statement separately',
    aumico_annual_report_import_optional_settings_title: 'Import Options',

    aumico_annual_report_import_choose_annual_report_for_autofill_and_mapping_button:
        'Choose the annual report to take upload/mapping autofill from',
    aumico_annual_report_import_select_annual_report_for_autofill_and_mapping:
        'Select an annual report to take upload/mapping autofill from',

    // interpretation
    aumico_annual_report_interpretation_title: 'Interpretation of numbers in the Financial Statement',
    aumico_annual_report_interpretation_select_signs:
        'Please select how the numbers will be delivered for each account type',
    aumico_annual_report_interpretation_active: 'Active',
    aumico_annual_report_interpretation_passive: 'Passive',
    aumico_annual_report_interpretation_income: 'Income',
    aumico_annual_report_interpretation_expense: 'Expense',
    aumico_annual_report_interpretation_positive: 'Positive',
    aumico_annual_report_interpretation_negative: 'Negative',
    aumico_annual_report_interpretation_specify_number_of_characters:
        'Optional: Please specify the number of characters of each field',
    aumico_annual_report_interpretation_account_number: 'Account number',
    aumico_annual_report_interpretation_account_number_invalid_input:
        'Only positive numbers or ranges (e.g. 3 or 3-5) are allowed.',
    aumico_annual_report_interpretation_account_name: 'Account name',
    aumico_annual_report_interpretation_opening_value: 'Opening value',
    aumico_annual_report_interpretation_closing_value: 'Closing value',
    aumico_annual_report_interpretation_specify_included_word:
        'Optional: Please specify one word that must be included in the account name',
    aumico_annual_report_interpretation_included_word: 'Included word',
    aumico_annual_report_interpretation_specify_excluded_word:
        'Optional: Please specify one word that must be excluded in the account name',
    aumico_annual_report_interpretation_remove_account_with_zero_balance: 'Remove accounts with zero balance',
    aumico_annual_report_interpretation_excluded_word: 'Excluded word',
    aumico_annual_report_interpretation_enter_excluded_word: 'Enter excluded word',
    aumico_annual_report_interpretation_enter_included_word: 'Enter included word',
    aumico_annual_report_export_to_word: 'Export Word',
    // import form
    aumico_annual_report_import_form_balance_instruction_text: 'Drag & Drop the balance file of the client here',
    aumico_annual_report_import_form_income_instruction_text:
        'Drag & Drop the income statement file of the client here',
    aumico_annual_report_import_form_balance_title: 'Balance sheet',
    aumico_annual_report_import_form_income_title: 'Income statement',
    aumico_annual_report_import_form_upload_label: 'Upload file for the net balance of the client',
    aumico_annual_report_import_form_uploaded_label: 'Uploaded file for the net balance of the client',
    aumico_annual_report_import_form_version_label: 'Version name (mandatory)',
    aumico_annual_report_import_form_input_placeholder: 'Please specify a version name',
    aumico_annual_report_import_form_balance_start: 'Please specify the starting row for balance accounts',
    aumico_annual_report_import_form_balance_end: 'Please specify the last row for balance accounts',
    aumico_annual_report_import_form_income_start: 'Please specify the starting row for income accounts',
    aumico_annual_report_import_form_income_end: 'Please specify the last row for income accounts',
    aumico_annual_report_import_form_error_invalid_row_input: 'Invalid row input',
    aumico_annual_report_import_form_error_overlapping: 'Ranges for balance & income accounts are overlapping',

    // print options
    aumico_annual_report_print_options_title: 'Print options',
    aumico_annual_report_print_options_caption:
        'Work instruction dolor sit amet, consetetur sadipscing elitr,sed diamnonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, seddiam voluptua.',
    aumico_annual_report_print_options_show_company_info: 'Show company information',
    aumico_annual_report_print_options_show_cover_sheet: 'Show cover sheet',
    aumico_annual_report_print_options_show_uid: 'Show UID on cover',
    aumico_annual_report_print_options_show_table_of_contents: 'Show table of contents',
    aumico_annual_report_print_options_hide_decimal_places: 'Hide decimal places',
    aumico_annual_report_print_options_remove_empty_lines: 'Remove empty lines',
    aumico_annual_report_print_options_print_only_greyscale: 'Print only greyscale',
    aumico_annual_report_print_options_add_metadata: 'Add metadata',
    aumico_annual_report_print_options_custom_page_numbers: 'Custom page numbers',
    aumico_annual_report_print_options_show_aop: 'Show Appropriation of Profit',
    aumico_annual_report_print_options_show_cfs: 'Show Cash Flow Statement',
    aumico_annual_report_print_options_show_notes: 'Show Notes',
    aumico_annual_report_print_options_complementary_reports: 'Show complementary reports',
    aumico_annual_report_print_options_signature: 'Signature',
    aumico_annual_report_print_options_place_of_signing: 'Place of Signing (Optional)',
    aumico_annual_report_print_options_place_of_signing_placeholder: 'Place of Signing',
    aumico_annual_report_print_options_collective_signature: 'Collective Signature',
    aumico_annual_report_print_options_signatory_1: 'Signatory 1 (optional)',
    aumico_annual_report_print_options_signatory_2: 'Signatory 2 (optional)',
    aumico_annual_report_print_options_label_show_reclasses_in_sums: 'Show reclasses in sums',
    aumico_annual_report_print_options_label_show_adjustments_in_sums: 'Show adjustment in sums',
    aumico_annual_report_print_options_dont_show_name: 'Do not show name (can be entered manually)',
    aumico_annual_report_print_options_show_organization_logo: 'Show Logo',
    aumico_annual_report_print_options_print: 'Print',
    aumico_annual_report_print_options_start_at_page: 'Start at Page',
    aumico_annual_report_print_options_date_of_signing: 'Date of Signing',
    aumico_annual_report_print_options_mainTitle: 'Title',
    aumico_annual_report_print_options_subTitle: 'Subtitle',
    aumico_annual_report_print_options_date: 'Date',
    aumico_annual_report_print_options_design_settings_title: 'Design Settings',
    aumico_annual_report_print_options_show_components_title: 'Show components',
    aumico_annual_report_print_options_decimal_and_empty_lines_title: 'Decimal and Empty Lines',
    aumico_annual_report_print_options_reclasses_and_internal_title: 'Reclasses and Internal',
    aumico_annual_report_print_options_disable_balance_sheet_page_break: 'Disable balance sheet page break',
    aumico_annual_report_print_options_place_signature_after_aop: 'Place Signature after AOP',
    aumico_annual_report_print_options_label_show_ratios: 'Show ratios',
    aumico_annual_report_print_options_label_show_shareholderInformation: 'Show shareholder info',
    aumico_annual_report_print_options_label_income_ratio_reference: 'Income Ratio Reference',
    aumico_annual_report_print_options_income_ratio_reference_internal_change_warning_message:
        'Please be aware that the value you selected as income ratio reference has been changed by the system.This is due to the fact that the opening or closing value of the previously selected item became 0',
    aumico_annual_report_print_options_show_ems: 'show EMS',
    aumico_annual_report_print_options_show_account_numbers: 'Show account numbers',
    aumico_annual_report_print_options_fin_statement: 'Financial Statement',
    aumico_annual_report_print_options_notes: 'Notes',
    aumico_annual_report_print_options_aop: 'Appropriation Of Profit',
    aumico_annual_report_print_options_hide_decimal_places_in_values: 'Hide decimal places in values',
    aumico_annual_report_print_options_hide_decimal_places_in_ratios: 'Hide decimal places in ratios',
    aumico_annual_report_print_options_hide_empty_lines: 'Remove empty lines',
    aumico_annual_report_print_options_experimental_section: 'Experimental',
    aumico_annual_report_print_options_experimental_section_description:
        'This is an experimental section and you can use new print options.',
    aumico_annual_report_print_options_experimental_section_text:
        'Please note that this print options only work if you are printing with the new print button and the are not reflected in the preview.',
    aumico_annual_report_print_options_label_non_breaking_hyphen_toggle: 'Non breaking hyphen',
    aumico_annual_report_print_options_repeat_appendix_title: 'Repeat appendix title on every page',
    aumico_annual_report_print_options_round_to_thousands: 'Round values to thousands',

    // aop general
    aumico_annualreport_aop_word_before_currency: 'in',
    // proposal table
    aumico_annual_report_proposal_description: 'Proposal for the appropriation of retained earnings.',
    aumico_annual_report_proposal_description_profit: 'Proposal for the appropriation of profit',
    aumico_annual_report_proposal_description_loss: 'Proposal for the appropriation of loss',
    aumico_annual_report_proposal_carried_forward_to_new_account: 'Carried forward to new account',
    aumico_annual_report_proposal_carried_forward_to_new_account_profit: 'Profit carried forward to new account',
    aumico_annual_report_proposal_carried_forward_to_new_account_loss: 'Loss carried forward to new account',
    aumico_annual_report_proposal_available_retained_earnings: 'Available retained earnings',
    aumico_annual_report_proposal_available_retained_earnings_profit: 'Total retained profit',
    aumico_annual_report_proposal_available_retained_earnings_loss: 'Total retained loss',
    aumico_annual_report_proposal_add_new_item: 'Add new item',
    aumico_annual_report_proposal_enter_text: 'Enter text',

    // profit calculation table
    aumico_annual_report_profit_calculation_header: 'Proposal for the appropriation of retained earnings',
    aumico_annual_report_profit_calculation_header_profit: 'Available profit',
    aumico_annual_report_profit_calculation_header_loss: 'Available loss',

    aumico_annual_report_profit_calculation_annual_profit: 'Annual Profit',
    aumico_annual_report_profit_calculation_annual_result: 'Annual Result',
    aumico_annual_report_profit_calculation_annual_loss: 'Annual Loss',
    aumico_annual_report_profit_calculation_enter_text: 'Enter text',

    aumico_annual_report_label_cover_page: 'Cover Page Guide Title (will not be visible in the pdf)',
    aumico_annual_report_label_table_of_contents: 'Table of contents Guide Title (will not be visible in the pdf)',

    // cash flow statement
    aumico_annual_report_cash_flow_button_recalculate_flis: 'Recalculate Flis from mapping',
    aumico_annual_report_cash_flow_operating_activities_title: 'Cash flow from business activities',
    aumico_annual_report_cash_flow_add_new_item: 'Add new item',
    aumico_annual_report_cash_flow_total: 'Total',
    aumico_annual_report_cash_flow_investing_activities_title: 'Cash flow from investing activities',
    aumico_annual_report_cash_flow_investing_activities_investments: 'Investments',
    aumico_annual_report_cash_flow_investing_activities_disinvestments: 'Disinvestments',
    aumico_annual_report_cash_flow_financing_activities_title: 'Cash flow from financing activities',
    aumico_annual_report_cash_flow_total_total1: 'Total 1',
    aumico_annual_report_cash_flow_total_total2: 'Total 2',
    aumico_annual_report_cash_flow_total_cashAndCashStart: 'Cash and cash equivalents at beginning of period',
    aumico_annual_report_cash_flow_total_cashAndCashEnd: 'Cash and cash equivalents at end of period',
    aumico_annual_report_cash_flow_total_total1_name: 'Total Change in Cash',
    aumico_annual_report_cash_flow_total_total2_name: 'Total Change in Cash',
    aumico_annual_report_cash_flow_total_recapitulation: 'Recapitulation',
    aumico_annual_report_cash_flow_print_preview_notes: 'Notes',
    aumico_annual_report_cash_flow_system_value_tooltip: 'System',
    aumico_annual_report_cash_flow_reset_to_system_value: 'Reset to system value',
    aumico_annual_report_print_options_show_accounts: 'Show Accounts',

    //Equity Movement Schedule
    aumico_annual_report_ems_text_addition_above_title: 'Text Above Ems',
    aumico_annual_report_ems_text_addition_below_title: 'Text Below Ems',

    // complementary reports
    aumico_annual_report_complementary_reports_headline: 'Headline',
    aumico_annual_report_complementary_reports_description: 'Description',
    aumico_annual_report_complementary_reports_add_report_button: 'Add report',
    aumico_annual_report_complementary_reports_report_title: 'Report title',
    aumico_annual_report_complementary_reports_report_rich_text_placeholder: 'Placeholder',
    aumico_annual_report_complementary_reports_title_error: 'Error: Title is required.',
    aumico_annual_report_complementary_reports_text_snippets_dialog_insert_text_snippet_button: 'Insert Snippet',
    aumico_annual_report_complementary_reports_text_snippets_dialog_title: 'Insert predefined text snippet',
    aumico_annual_report_complementary_reports_delete_icon_text: 'Delete',
    aumico_annual_report_complementary_reports_prefill_with_text_snippet_icon_text: 'Prefill with text snippet',
    aumico_annual_report_complementary_reports_text_snippets_dialog_description: 'Description',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_yes_button: 'Yes',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_cancel_button: 'Cancel',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_description:
        'Are you sure ? You are going to overwrite your text box',

    // text snippets
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field: 'Description',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field: 'Title',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_required_error:
        'Description is required',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field_required_error: 'Title is required',
    aumico_reports_organization_settings_text_snippets_form_dialog_content_field_required_error: 'Content is required',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_already_exists_error:
        'Description already exists',
    aumico_reports_organization_settings_text_snippets_form_dialog_cancel_button: 'cancel',
    aumico_reports_organization_settings_text_snippets_form_dialog_save_button: 'save',
    aumico_reports_organization_settings_text_snippets_create_dialog_title: 'Add new text snippet',

    aumico_reports_organization_settings_text_snippets_list_created_at_column_header: 'Created at',
    aumico_reports_organization_settings_text_snippets_list_created_by_column_header: 'Created by',
    aumico_reports_organization_settings_text_snippets_list_description_column_header: 'Description',
    aumico_reports_organization_settings_text_snippets_list_last_modified_column_header: 'Last modified',
    aumico_reports_organization_settings_text_snippets_list_modified_by_column_header: 'Modified by',
    aumico_reports_organization_settings_text_snippets_list_title_column_header: 'Title',

    aumico_reports_organization_settings_text_snippets_list_delete_button: 'Delete',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_cancel_button: 'Cancel',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_description: 'Description',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_yes_button: 'Yes',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_description:
        'Failed to delete text snippets: Internal server error.',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_description:
        'Text snippets deleted successfully.',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_title: 'Error',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_title: 'Successful',

    // annual report selection list
    aumico_annual_report_selection_list_company: 'Company',
    aumico_annual_report_selection_list_legal_form: 'Legal Form',
    aumico_annual_report_selection_list_accounting_basis: 'Accounting Basis',
    aumico_annual_report_selection_list_current_year_date: 'Current year',

    aumico_annual_report_aop_accounts_placeholder: 'Select Account',

    // consistency checks table in print preview
    aumico_reports_equality_check_print_preview_table_title: 'Checks',
    aumico_reports_equality_check_print_preview_title: 'Consistency Checks',
    aumico_reports_equality_check_print_preview_table_previous_year_column: 'Previous Year',
    aumico_reports_equality_check_print_preview_table_current_year_column: 'Current Year',
    aumico_reports_equality_check_print_preview_table_assets_equal_liabilities: 'Assets = Liabilities',
    aumico_reports_equality_check_print_preview_table_cashflow_statement: 'Cashflow Statement',
    aumico_reports_equality_check_print_preview_table_profit_income_equals_profit_fli: 'Profit Income = Profit FLI',
    aumico_reports_equality_check_print_preview_table_reclasses: 'Reclasses',
    aumico_reports_equality_check_print_preview_table_adjustments: 'Adjustments',
    aumico_reports_equality_check_print_preview_table_reclasses_profit_income_equals_reclasses_profit_balance:
        'Reclasses Profit Income = Reclasses Profit Balance',
    aumico_reports_equality_check_print_preview_table_adjustments_profit_income_equals_adjustments_profit_balance:
        'Adjustments Profit Income = Adjustments Profit Balance',
    aumico_reports_equality_check_print_preview_table_previous_year_row: 'Previous Year',
    aumico_reports_equality_check_print_preview_table_current_year_row: 'Current Year',
    aumico_reports_equality_check_print_preview_information_dialog_content: 'This shows the consistency checks result',

    aumico_information_dialog_title: 'Information',

    // placeholders
    aumico_annual_report_form_placeholder_please_enter: 'Please enter',

    // Sheets Dates Generation keys
    aumico_general_information_autofill_date_popup_autofill_btn: 'autofill',
    aumico_general_information_autofill_date_popup_content: 'Do you want to autofill other dates?',
    aumico_general_information_autofill_date_popup_no_autofill_btn: "don't fill",

    // AR Template
    aumico_admin_ar_template_list_menu_item_delete: 'Delete',
    aumico_admin_ar_template_list_delete_success_notification_title: 'Success',
    aumico_admin_ar_template_list_delete_success_notification_description:
        'Annual report template deleted successfully',
    aumico_admin_ar_template_list_delete_failed_notification_title: 'Error',
    aumico_admin_ar_template_list_delete_error_notification_description: 'Failed to delete annual report template',
    aumico_reports_annualreport_navigation_generalinformation: 'General Information',
    aumico_reports_annualreport_navigation_import: 'Import Balance Sheet',
    aumico_reports_annualreport_navigation_fcp: 'Financial Closing Process',
    aumico_reports_annualreport_navigation_balance_account_proof: 'Balance Account Proof',
    aumico_reports_annualreport_navigation_income_account_proof: 'Income Account Proof',
    aumico_reports_annualreport_navigation_equity_movement_schedule: 'Equity Movement',
    aumico_reports_annualreport_navigation_fixed_assets_schedule: 'Fixed Assets',
    aumico_reports_annualreport_navigation_adjustments_and_reclasses: 'Adjustments & Reclasses',
    aumico_reports_annualreport_navigation_complementary_reports: 'Complementary Reports',
    aumico_reports_annualreport_navigation_finish_and_print: 'Finish & Print',
    aumico_reports_annualreport_navigation_cfs: 'Cash Flow Statement',
    aumico_reports_annualreport_navigation_notes: 'Notes',
    aumico_reports_annualreport_navigation_aop: 'Appropriation of profits',

    // CCR (Capital Contribution Reserves / Kapitaleinlagereserven)
    aumico_annual_report_ccr_description: 'aumico_annual_report_ccr_description',
    aumico_annual_report_ccr_beginning_of_year: 'aumico_annual_report_ccr_beginning_of_year',
    aumico_annual_report_ccr_end_of_year: 'aumico_annual_report_ccr_end_of_year',
    aumico_annual_report_ccr_select_account: 'aumico_annual_report_ccr_select_account',
    aumico_annual_report_ccr_add_new_item: 'aumico_annual_report_ccr_add_new_item',
    aumico_annual_report_ccr_enter_text: 'aumico_annual_report_ccr_enter_text',
    aumico_annual_report_ccr_enter_value: 'aumico_annual_report_ccr_enter_value',
    aumico_annual_report_ccr_toggle_show: 'aumico_annual_report_ccr_toggle_show',
    aumico_annual_report_ccr_toggle_hide: 'aumico_annual_report_ccr_toggle_hide',
    aumico_annual_report_ccr_diff_prior: 'aumico_annual_report_ccr_diff_prior',
    aumico_annual_report_ccr_diff_cur: 'aumico_annual_report_ccr_diff_cur',
    aumico_annual_report_ccr_add_comment: 'aumico_annual_report_ccr_add_comment',
    aumico_annual_report_ccr_remove_comment_confirm: 'aumico_annual_report_ccr_remove_comment_confirm',

    aumico_admin_ar_template_define_pdf_template: 'Define PDF Template',
    aumico_admin_ar_template_general_information_legal_forms: 'Legal Forms',
    aumico_admin_ar_template_general_information_business_models: 'Business Model',
    aumico_admin_ar_template_general_information_state: 'State',
    aumico_admin_ar_template_general_information_accounting_bases: 'Accounting Bases',
    aumico_admin_ar_template_general_information_annual_report_steps: 'Annual Report Navigation Steps',
    aumico_admin_ar_template_general_information_consistency: 'Consistency',
    aumico_admin_ar_template_general_information_countries: 'Countries',
    aumico_admin_ar_template_general_information_name: 'Name',
    aumico_admin_ar_template_specifications: 'Specifications',
    aumico_admin_ar_template_table_actions: 'actions',
    aumico_admin_ar_template_download_pdf_template: 'Download PDF Template',
    aumico_admin_ar_template_general_information_field_required_error: 'This field is required',

    aumico_admin_ar_template_pdf_error_notification_description_file_type_invalid:
        'Failed to upload PDF Template: file type must be docx',
    aumico_admin_ar_template_list_reporting_template_name: 'Pdf template name',

    // // sections
    // aumico_annual_report_form_section_name_contact_details: 'Contact details',

    // // toasts
    // aumico_annual_report_toast_error_something_went_wrong: 'Something went wrong',
} as const;

type PickTypeOfKey<T> = {
    [P in keyof T]: P;
};

// just getting the value of the key: key
export const localizationKeys = Object.keys(defaultLocalizationValues).reduce((acc, key) => {
    acc[key] = key;
    return acc;
}, {} as PickTypeOfKey<typeof defaultLocalizationValues>);
